import { Navbar, Footer } from './LandingPage';
import { WanderfulHero } from './WanderfulHero';
import { ArrowRight, Briefcase, MapPin, Clock, Rocket, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CareersPage = () => {
  const navigate = useNavigate();
  const jobs = [
    {
      title: "Senior AI Engineer (Computer Vision)",
      location: "Bengaluru / Remote",
      type: "Full-time",
      department: "Engineering"
    },
    {
      title: "Product Designer (UX/UI)",
      location: "Delhi NCR",
      type: "Full-time",
      department: "Product"
    },
    {
      title: "Business Development Manager",
      location: "Mumbai",
      type: "Full-time",
      department: "Sales"
    },
    {
      title: "Content Marketing Lead",
      location: "Remote",
      type: "Full-time",
      department: "Marketing"
    }
  ];

  return (
    <div className="bg-white min-h-screen font-sans">
      <Navbar />
      <WanderfulHero 
        title="Help us mark the next billion pages."
        subtitle="We're looking for problem-solvers who are passionate about education and want to build the future of AI evaluation in India."
        cta1Text="Open Roles"
        cta1Link="#open-roles"
      />

      <section id="open-roles" className="py-8 sm:py-12 md:py-24 bg-white relative overflow-hidden">
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-[0.02] bg-[linear-gradient(to_right,#000_1px,transparent_1px),linear-gradient(to_bottom,#000_1px,transparent_1px)] bg-[size:30px_30px]" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="text-center mb-16 sm:mb-20">
            <span className="text-xs font-bold text-black uppercase tracking-[0.2em] bg-black/5 px-4 py-2 rounded-full border border-black/10">Join Us</span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-black mt-6">Open Opportunities</h2>
            <p className="text-gray-500 max-w-2xl mx-auto mt-4 font-medium text-base">Build something that matters. Join a fast-growing startup with a mission to transform education.</p>
          </div>

          <div className="grid grid-cols-1 gap-4 max-w-4xl mx-auto">
            {jobs.map((job, i) => (
              <div key={i} className="group bg-white hover:bg-black border border-gray-200 hover:border-black rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 transition-all duration-300 flex flex-col md:flex-row md:items-center justify-between cursor-pointer shadow-sm hover:shadow-2xl">
                <div>
                   <span className="text-[9px] font-extrabold text-black group-hover:text-white uppercase tracking-widest bg-black/5 group-hover:bg-white/10 border border-black/10 group-hover:border-white/20 px-3 py-1 rounded-full mb-3 inline-block">
                     {job.department}
                   </span>
                   <h3 className="text-xl font-bold text-black group-hover:text-white transition-colors mb-2">{job.title}</h3>
                   <div className="flex items-center gap-6 text-sm text-gray-500 group-hover:text-white/60 transition-colors">
                      <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4" /> {job.location}</span>
                      <span className="flex items-center gap-1.5"><Clock className="w-4 h-4" /> {job.type}</span>
                   </div>
                </div>
                <button onClick={() => navigate('/support')} className="mt-6 md:mt-0 bg-black group-hover:bg-white text-white group-hover:text-black border border-transparent rounded-full px-8 py-3.5 font-bold transition-all duration-300 flex items-center justify-center gap-2">
                   Apply Now <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            ))}
          </div>

          {/* Benefits Section */}
          <div className="mt-16 sm:mt-24 md:mt-32">
             <div className="text-center mb-16">
                <span className="text-xs font-bold text-black uppercase tracking-[0.2em] bg-black/5 px-4 py-2 rounded-full border border-black/10">Benefits</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-black mt-6">Why Parakh?</h2>
             </div>

             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-5xl mx-auto">
                <div className="p-4 sm:p-6 md:p-8 border border-gray-150 rounded-2xl sm:rounded-3xl bg-white hover:border-black transition-colors duration-300">
                   <div className="w-14 h-14 rounded-2xl bg-black text-white flex items-center justify-center mb-6 shadow-md">
                      <Briefcase className="w-6 h-6" />
                   </div>
                   <h4 className="text-xl font-bold text-black mb-3">Meaningful Work</h4>
                   <p className="text-gray-500 text-xs leading-relaxed font-medium">Your code and designs directly impact the learning outcomes of millions of students across India.</p>
                </div>
                <div className="p-8 border border-gray-150 rounded-3xl bg-white hover:border-black transition-colors duration-300">
                   <div className="w-14 h-14 rounded-2xl bg-black text-white flex items-center justify-center mb-6 shadow-md">
                      <Rocket className="w-6 h-6" />
                   </div>
                   <h4 className="text-xl font-bold text-black mb-3">Rapid Growth</h4>
                   <p className="text-gray-500 text-xs leading-relaxed font-medium">As an early-stage startup, you'll have immense ownership and the opportunity to grow at light speed.</p>
                </div>
                <div className="p-8 border border-gray-150 rounded-3xl bg-white hover:border-black transition-colors duration-300">
                   <div className="w-14 h-14 rounded-2xl bg-black text-white flex items-center justify-center mb-6 shadow-md">
                      <Users className="w-6 h-6" />
                   </div>
                   <h4 className="text-xl font-bold text-black mb-3">Peers</h4>
                   <p className="text-gray-500 text-xs leading-relaxed font-medium">Work with some of the sharpest minds from IITs and NIDs in a collaborative, ego-free environment.</p>
                </div>
             </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CareersPage;
